import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store.js";
import About from "../views/Pages/About.vue";
import Home from "../views/Home.vue";

Vue.use(Router);

const router = new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/features",
      name: "features",
      component: () => import("../views/Pages/Features.vue"),
    },
    {
      path: "/books",
      name: "books",
      component: () => import("../views/PagesListData/Books.vue"),
    },
    {
      path: "/videos",
      name: "videos",
      component: () => import("../views/PagesListData/Video.vue"),
    },
    {
      path: "/blogs",
      name: "blogs",
      component: () => import("../views/PagesListData/Blogs.vue"),
    },
    {
      path: "/news",
      name: "news",
      component: () => import("../views/PagesListData/News.vue"),
    },
    {
      path: "/audios",
      name: "audios",
      component: () => import("../views/PagesListData/Audio.vue"),
    },
    {
      path: "/contact",
      name: "contactus",
      component: () => import("../views/Pages/ContactUs.vue"),
    },
    {
      path: "/BookDetails/:ID?",
      name: "BookDetails",
      component: () => import("../views/PageDetails/BookDetails.vue"),
    },
    {
      path: "/BookDetailsBrief/:ID?",
      name: "BookDetailsBrief",
      component: () => import("../views/PageDetails/BookDetailsBrief.vue"),
    },
    ,
    {
      path: "/Complain/:ID?",
      name: "Complain",
      component: () => import("../views/PageDetails/Complain.vue"),
    },
    {
      path: "/BlogDetails/:ID?",
      name: "BlogDetails",
      component: () => import("../views/PageDetails/BlogDetails.vue"),
    },
    {
      path: "/NewsDetails/:ID?",
      name: "NewsDetails",
      component: () => import("../views/PageDetails/NewsDetails.vue"),
    },
    {
      path: "/SinksarAndKatamarsDetails",
      name: "SinksarAndKatamarsDetails",
      component: () =>
        import("../views/PageDetails/SinksarAndKatamarsDetails.vue"),
    },
    {
      path: "/VideoDetails/:ID?",
      name: "VideoDetails",
      component: () => import("../views/PageDetails/VideoDetails.vue"),
    },
    {
      path: "/Favorites",
      name: "Favorites",
      component: () => import("../views/PageDetails/Favorite.vue"),
    },
    {
      path: "/support",
      name: "support",
      component: () => import("../views/Pages/Support.vue"),
    },
    {
      path: "/pricing",
      name: "pricing",
      component: () => import("../views/Pages/Pricing.vue"),
    },
    {
      path: "/search",
      name: "search",
      component: () => import("../views/Pages/Search.vue"),
    },
    {
      path: "/portfolio-v1",
      name: "portfoliov1",
      component: () => import("../views/Pages/PortfolioV1.vue"),
    },
    {
      path: "/portfolio-v2",
      name: "portfoliov2",
      component: () => import("../views/Pages/PortfolioV2.vue"),
    },
    {
      path: "/portfolio-v3",
      name: "portfoliov3",
      component: () => import("../views/Pages/PortfolioV3.vue"),
    },
    {
      path: "/testimonial-v1",
      name: "testimonialv1",
      component: () => import("../views/Pages/TestimonialV1.vue"),
    },
    {
      path: "/testimonial-v2",
      name: "testimonialv2",
      component: () => import("../views/Pages/TestimonialV2.vue"),
    },
    {
      path: "/blog-listing-sidebar",
      name: "bloglisitingsidebar",
      component: () => import("../views/Blogs/BlogLisitingSidebar.vue"),
    },
    {
      path: "/blog-detail",
      name: "blogdetail",
      component: () => import("../views/Blogs/BlogDetail.vue"),
    },
    {
      path: "/blog-column2",
      name: "blogcolumn2",
      component: () => import("../views/Blogs/BlogColumn2.vue"),
    },
    {
      path: "/blog-column3",
      name: "blogcolumn3",
      component: () => import("../views/Blogs/BlogColumn3.vue"),
    },
    {
      path: "/blog-masonry2",
      name: "blogmasonry2",
      component: () => import("../views/Blogs/BlogMasonry2.vue"),
    },
    {
      path: "/blog-masonry3",
      name: "blogmasonry3",
      component: () => import("../views/Blogs/BlogMasonry3.vue"),
    },
    {
      path: "/sidebar-widgets",
      name: "sidebarwidgets",
      component: () => import("../views/Features/Widgets.vue"),
    },
    //   {
    //     path: "/login",
    //     name: "login",
    //     component: () => import("../views/Features/Login.vue"),
    //   },
    // {
    //   path: "/sign-up",
    //   name: "signup",
    //   component: () => import("../views/Features/SignUp.vue"),
    // },
    {
      path: "/thank-you",
      name: "thankyou",
      component: () => import("../views/Features/ThankYou.vue"),
    },
    {
      path: "/not-found",
      name: "notfound",
      component: () => import("../views/Features/NotFound.vue"),
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: () => import("../views/Features/Maintenance.vue"),
    },
    {
      path: "/blog-sidebar",
      name: "blogsidebar",
      component: () => import("../views/Blogs/BlogSidebar.vue"),
    },
    {
      path: "/blog-no-sidebar",
      name: "blognosidebar",
      component: () => import("../views/Blogs/BlogNoSidebar.vue"),
    },
    {
      path: "/product-grid",
      name: "productgrid",
      component: () => import("../views/Shop/ProductGrid.vue"),
    },
    {
      path: "/product-cart",
      name: "productcart",
      component: () => import("../views/Shop/ProductCart.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/User/Login/Login.vue"),
    },
    {
      path: "/signup",
      name: "signup",
      component: () => import("../views/User/User/Signup.vue"),
    },
    {
      path: "/editProfile",
      name: "editProfile",
      component: () => import("../views/User/User/EditProfile.vue"),
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: () => import("../views/User/User/ChangePassword.vue"),
    },
    {
      path: "/product-checkout",
      name: "productcheckout",
      component: () => import("../views/Shop/ProductCheckout.vue"),
    },
    {
      path: "/product-detail",
      name: "productdetail",
      component: () => import("../views/Shop/ProductDetail.vue"),
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
// router.beforeEach((to, from, next) => {
//   const publicPages = ["/login", "/signup"];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem("userInfo");

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     store.commit("REMOVE_USER_STORE", null, { root: true });
//     next("/login");
//   } else {
//     next();
//   }
// });

// });

export default router;
